import { render, staticRenderFns } from "./TeachOtoAppoint.vue?vue&type=template&id=b2f7d2dc&"
import script from "./TeachOtoAppoint.vue?vue&type=script&lang=js&"
export * from "./TeachOtoAppoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports